<div ngbDropdown autoClose="outside" placement="bottom-end">
  <button class="btn btn-primary--blue btn-md w-100" ngbDropdownToggle>
    <span>{{ 'global.address.chooseOther' | translate }}</span>
    <i class="fas fa-chevron-down transition-all text-white ml-2" aria-hidden="true" [ngClass]="{ 'rotate-x-180': !isCollapsed() }"></i>
  </button>
  <div>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end" data-test="address-selection-dropdown">
      @for (option of addressOptions(); track option) {
        @if (option?.address) {
          <button
            ngbDropdownItem
            class="dropdown-item"
            (click)="onAddressSelected(option)"
            [ngClass]="{ 'dropdown-item-checked': isAddressSelected(option.address) }"
          >
            @if (option.address.addressGroup?.groupName) {
              <div>{{ option.address.addressGroup.groupName }}</div>
            }
            <div>{{ option.address | getAddressPostCodeAndStreet }}</div>
          </button>
        }
      }
    </div>
  </div>
</div>
